import type mapboxgl from 'mapbox-gl';

export const waitForStyle = async (map: mapboxgl.Map) => {
  if (map.isStyleLoaded()) {
    return;
  }

  await new Promise<void>((resolve) => {
    map.once('load', () => resolve());
  });
};

export const waitForFloorPlanSource = async (map: mapboxgl.Map) => {
  const floorPlanSourceId = 'MI_FLOOR_PLAN_SOURCE';

  if (map.getSource(floorPlanSourceId) && map.isSourceLoaded(floorPlanSourceId)) {
    return;
  }

  await new Promise<void>((resolve) => {
    const handleSourceData = (event: mapboxgl.MapSourceDataEvent) => {
      if (event.sourceId !== floorPlanSourceId) {
        return;
      }

      if (map.isSourceLoaded(floorPlanSourceId)) {
        map.off('sourcedata', handleSourceData);
        resolve();
      }
    };

    map.on('sourcedata', handleSourceData);
  });
};
